import { Row, Col, H2, TertiaryLink } from '@everlywell/leaves';
import { GatsbyImage as Img, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import { generateKey } from 'utils/helpers';
import { CTA } from 'utils/types';
import * as S from './styles';

type ContentWithImage = {
  heading: string;
  description: string;
  image: IGatsbyImageData;
  imageAlt: string;
  cta: CTA;
};

export interface Props {
  title: string;
  headline: string;
  listOfContentWithImages: ContentWithImage[];
}

export const InTheNewsSection: React.FC<Props> = ({
  title,
  headline,
  listOfContentWithImages,
}) => {
  if (!listOfContentWithImages) {
    return null;
  }
  return (
    <S.NewsBackground>
      <S.NewsContainer>
        <Row center="xs">
          <Col xs={12} lg={10}>
            <H2>{title}</H2>
          </Col>
        </Row>
        {headline ? (
          <Row center="xs">
            <Col xs={12} lg={10}>
              <H2>{headline}</H2>
            </Col>
          </Row>
        ) : null}
        <Row center="xs">
          <S.QuotesSections>
            {listOfContentWithImages.map((content) => (
              <S.NewsCol key={generateKey()} xs={12} md={6} lg={5}>
                <S.QuoteContainer>
                  {content.image ? (
                    <Img
                      image={content.image}
                      alt={content.imageAlt}
                      style={{ maxHeight: '2.187rem' }}
                      imgStyle={{ width: 'fit-content', objectFit: 'contain' }}
                    />
                  ) : null}
                  {content.heading ? (
                    <S.QuoteText>{content.heading}</S.QuoteText>
                  ) : null}
                  <S.QuoteText>{content.description}</S.QuoteText>
                  {content.cta ? (
                    <TertiaryLink href={content.cta.url}>
                      {content.cta.text}
                    </TertiaryLink>
                  ) : null}
                </S.QuoteContainer>
              </S.NewsCol>
            ))}
          </S.QuotesSections>
        </Row>
      </S.NewsContainer>
    </S.NewsBackground>
  );
};

export default InTheNewsSection;
